import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/index.scss'
//引入vxe-table组件
import VXETable from '@/plugins/index'
import 'vxe-table/lib/style.css'
//引入指令
import directives from "./directives/index"
//引入nprogress样式
import 'nprogress/nprogress.css'


const app = createApp(App)

app.use(store)
app.use(router)
app.use(directives)
app.use(VXETable)
app.mount('#app')
